"use strict";

exports.__esModule = true;
exports.fetchSection = fetchSection;
var _react = _interopRequireDefault(require("react"));
var _Metrics = require("../../../Catalogs/Metrics");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _aggregates = require("./aggregates");
var _filters = require("./filters");
var _PlantStateActivities = require("../../PlantStateActivities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 *
 * Design Notes:
 * - While making API requests. Props, name, label will be removed from aggregates and filters while querying
 * -- fields in props are self explanatory
 */

var getFilters = function getFilters(_ref) {
  var states = _ref.states,
    activities = _ref.activities;
  return [_filters.deviceFilter, _filters.plantFilter, _filters.rangeFilter, _filters.excludeDaysInWeek, (0, _filters.scheduledStateFilter)(states), (0, _filters.scheduledActivityFilter)(activities), _filters.operatorFilter];
};
var aggregates = [_aggregates.byTime, _aggregates.byDevice, _aggregates.byShift, _aggregates.byState, _aggregates.byActivity, _aggregates.byKind, _aggregates.byProcess, _aggregates.byInstance, _aggregates.byOperator, _aggregates.byTool, _aggregates.byConditionLevel, _aggregates.byConditionType, _aggregates.byNativeCode, _aggregates.byConditionText];

// Will be a promise later and pass API as an arg
function fetchSection(section) {
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_react["default"].useContext(_PlantStateActivitiesContext.PlantStateActivitiesContext));
  var states = plantStateActivities.states,
    activities = plantStateActivities.activities;
  switch (section) {
    case "filters":
      return getFilters({
        states: states,
        activities: activities
      });
    case "aggregates":
      return aggregates;
    case "metrics":
      return _Metrics.metricDefinitions.map(function (metric) {
        return Object.assign({}, metric, {
          mergeProps: {
            sortIndex: metric.name
          }
        });
      });
    default:
      return [];
  }
}